import React from "react";
import { withShowIf } from "../../../../../../../../../../components/with-show-if/with-show-If.component";
import { FlyerDetailPagePreviewPositionEmptyProps } from "./flyer-detail-page-preview-position-empty.props";
import { PositionDetails } from "./flyer-detail-page-preview-position-empty.styles";
import {
  FlyerDetailPageDetailPositionLabel,
  FlyerDetailPagePreviewPositionCell,
} from "../../styles/flyer-detail-page-preview-cell.styles";

export const FlyerDetailPagePreviewPositionEmpty = withShowIf(
  (props: FlyerDetailPagePreviewPositionEmptyProps) => (
    <FlyerDetailPagePreviewPositionCell onClick={props.onClick}>
      <FlyerDetailPageDetailPositionLabel>{props.label}</FlyerDetailPageDetailPositionLabel>
      <PositionDetails>+ Position Details</PositionDetails>
    </FlyerDetailPagePreviewPositionCell>
  )
);
